module.exports = {
  // 左侧菜单栏配置
  menus: {
    a1:'quality',
    a2:'category',
    a3:'inventory',
    a4:'Delivery',
    b1:'Quality Assurance, Certified Merchant Fake One Compensation Three',
    b2:'Complete range of products, all available at one stop',
    b3:'Real time inventory to ensure availability',
    b4:'Local auto parts supplier services',
    center: 'User Center',
    Home: 'Admin',

    orders: 'My Order',
    bought: 'My Purchase',
    sold: 'My Sold',

    management: 'Store Mgt',
    shopList: 'Store List',
    Information: 'Store Info.',
    construction: 'Store Renovation',
    warehouse: 'Warehouse Inventory',

    marketing: 'Marketing Mgt',
    Events: 'Store Activity',

    Account: 'Account Mgt',
    personal: 'Profile',
    address: 'Receiving adr',
    Invoice: 'Invoice Set',

    organization: 'Org Mgt',
    employee: 'Employee List',
    role: 'Role Mgt',

    Financial: 'Financial Mgt',
    selfOperated: 'Self-Owned Account',
    Union: 'Alliance Account',
  },

  // 顶部、右侧导航栏
  navigation: {
  },

  // ZF首页
  home: {
    Accessories: 'Parts Search',
    store: 'Store Search',
    VIN: 'VIN Search',
    search: 'Search',
    placeholder1: 'Please enter store name',
    placeholder2: 'Please enter 17-digit VIN',
    placeholder3: 'Please enter part code/name, code supports multi-queries, please separate with Ctrl+Enter.',
    stores: 'Store',
    Only: 'Only Show Available',

    Information: 'Basic Info',
    place: 'Shipping adr',
    stock: 'Inventory',
    price: 'Price',
    Purchase: 'Purchase Quantity',
    operate: 'Operation',
    Bar:'Bar/Page',

    return: 'Return to Homepage',
    quit: 'Exit',
    welcome: 'Welcome',
    quote: 'Request Quote',
    cart: 'Shopping Cart',
    personal: 'User Center',
    focus: 'My Favorites',
    Back: 'Back to Top',
    immediately: 'Buy Now ',
    Inquire: 'Inquire Now ',
    info: 'No data found for your query',
    service: 'service：',
    oemCode: 'oemCode：',
    all:'ALL',
  },

  // 商品详情
  detail: {
    price: 'price',
    Inquire: 'Request Quote',
    discount: 'Discount',
    Serve: 'Service',
    stock: 'Inventory',
    MOQ: 'MIN Order Quantity',
    Purchase: 'Purchase Quantity',
    product: 'Product Details',
    Applicable: 'Applicable Vehicle Type',
    Accessory: 'Part Description',
    selling: 'Bestsellers',
    Monthly: 'Monthly Sales',
    Buy: 'Purchase',
    Home: 'Store Homepage',
    products: 'All Products',
    Search: 'Search in this Store',
    placeholder: 'Please enter part code/name',
    accessories: 'No part description available',
    Inventory: 'Insufficient stock',
    cart: 'Add to Cart',
    now: 'Buy Now',
    InquireNow: 'Request Quote Now',

    // 表格
    code: 'Part Code',
    brand: 'Brand',
    standard: 'Standard Group',
    alias: 'Alias',
    Related: 'Associated Original Part',
    type: 'Part Type',
    unit: 'Unit',
    name: 'Standard Name',
    carBrand: 'Vehicle Manufacturer',
    OEM: 'OEM',
    series: 'Vehicle Series',
    model: 'Vehicle Type',
    modelName: 'Vehicle Type Name',
    payment: 'Annual payment',
    Displacement: 'Displacement',
    gearbox: 'Transmission',
    gear: 'Gear',
    engine: 'Engine',
    info: 'No part description available',
  },

  // 询价页面
  Inquiry: {
    list: 'Inquiry List',
    Quote: 'Quotation List',

    // 表格
    number: 'Order No.',
    state: 'Status',
    information: 'Inquiry Info',
    product: 'Product Info',
    place: 'Shipping adr',
    quantity: 'Inquiry Quantity',
    QuoteInfo: 'Quotation Info',
    price: 'Unit Price ()',
    amount: 'Amount',
    operate: 'Operation',
    Inquirer: 'Inquirer',
    search: 'search',
    Accessory: 'Part Code/Part Name',
    OE: 'OE No.'
  },

  // 购物车页面
  shopping: {
    cart: 'Shopping Cart',
    Inquiry: 'Inquiry Cart',

    // 表格
    picture: 'Product Image',
    info: 'Product Info',
    place: 'Shipping adr',
    stock: 'Inventory',
    price: 'Unit Price ()',
    Purchase: 'Purchase Quantity',
    Subtotal: 'Subtotal ()',
    operate: 'Operation',

    select: 'Select All',
    delete: 'Delete',
    No: 'No data available',
    selected: 'Selected Items',
    pieces: 'Piece',
    Total: 'Subtotal (excluding shipping)',
    settlement: 'Checkout',
    Sorry: 'Sorry! Your shopping cart is empty~',
    Expired: 'Expired Items',
    Bulk: 'Bulk Import to Cart'
  },

  // 订单提交页面
  orderInformation: {
    address: 'Confirm Shipping Adr',
    New: 'Add Shipping Adr',
    Change: 'Modify Address',
    default: 'Default Address',
    More: 'More Address',
    Confirm: 'Confirm Order Info',

    // 表格
    Information: 'Basic Info',
    place: 'Shipping Adr',
    price: 'Unit Price ()',
    Purchase: 'Purchase Quantity',
    Subtotal: 'Subtotal ()',
    method: 'Delivery Method',
    Logistics: 'Express Delivery',
    pick: 'Pick Up in Store',
    Postage: 'Shipping fee is default COD (Cash on Delivery), please contact the seller for details',
    Non: ' Shipping fee is default COD (Cash on Delivery), please contact the seller for details',
    Total: 'Actual Payment',
    real: 'Submit Order',
    freight: 'Total Payable',
    fee: 'Store Total',
    Message: 'remark',
    workOrderCode:'code',
    Optional: 'Optional, please consult with the seller first',
    invoice: 'Invoice Type',
    info: 'Invoice Info',
    Reselect: 'Reselect',
    VAT: 'VAT Special Invoice',
    General: 'VAT General Invoice',
    ticket: 'Special Invoice',
    Popular: 'General Invoice',
    supplier: 'Supplier Invoice',
    noInvoice: 'No Invoice',
    invoicing: 'Invoice amount excluding shipping fees',
    delivery: 'Shipping fee is COD, based on the logistics company selected by the seller',
    Please: 'Please go to the User Center-Invoice Management to maintain invoice info',
    latest: 'Please return to the shopping cart to get the latest prices',
  },

  //我的订单
  myOrder: {
    allOrders: 'All Orders',
    pendingPayment: "Pending Payment",
    waitDelivery: 'Pending Shipment',
    waitReceived: 'Pending Delivery',
    completion: 'Transaction Completed',
    returnGoods: 'Refund/Return',
    claimApplication: 'Claim Application',
    orderNo: 'Order No.',
    partName: 'Part Code or Name',
    shopName: 'Store Name',
    selectDate: 'Select Order Date',
    clerk: 'Order Placer',
    reset: 'Reset',
    query: 'Search',
    status: 'Order Status',
    statusAll: "All",
    statusClose: 'Transaction Closed',
    statusCancel: 'Transaction Canceled',
    product: 'Product Info',
    place: ' Shipping adr',
    num: 'Quantity',
    price: 'Unit Price ( )',
    productStatus: 'Product Status',
    payInfo: 'Payment Info',
    operate: 'Operation',
    export: 'Export',
    orderDetails: 'Order Details',
    buyAgain: 'Buy Again',
    applyReturn: 'Apply for Refund',
    sellReturn: 'View Application',
    cancelReturn: 'Cancel Application',
    print: 'Print',
    Claim: 'Claim Status',

    Withdrawal: 'Cancel Claim',
    View: 'View Claim',
    completed: 'Claim Completed',
    Denied: 'Claim Rejected',
    application: 'Claim Application',
    goods: 'Product Amount',
    actually: 'Actual Amount',
    Return: 'Return Amount',
    Refund: 'Refund Amount',
    amount: 'Claim Amount',
    Payment: 'Pay',
    cancel: 'Cancel Order',
    receiving: 'Receive',
    viewApplication: 'View Application',
    canceled: 'Cancel Application',
    Request: 'Apply for Refund',
    Apply: 'Apply for Aftersales Service',
    buy: 'Buy Again',
    automatic: 'Auto Receive',

    left: 'Remaining',
    day: 'Days',
    Hour: 'Hours',
    point: 'Minutes',
    Second: 'Seconds',
    order: 'Order No.',
    Number: 'Claim No.',
    quantity: 'Quantity',
    yuan: 'Unit Price ( )',
    commodity: 'Product Status',
    info: 'Payment Info.',
    transaction: 'Transaction Operations',
  },

  //店铺管理--->店铺列表
  storeList: {
    registeredCompany: "Register Company",
    companyStatus: 'Company Status',
    companyName: 'Store Name',
    default: 'Default',
  },


  //店铺管理--->店铺信息
  storeInfo: {
    baseInfo: 'Basic Info.',
    mainInfo: 'Main Business Info.',
    attestationInfo: 'Certification Info.',
    storeName: 'Store Name',
    businessAddress: 'Business Adr',
    contacts: 'Contact Person',
    tel: 'Contact Phone No.',
    change: 'Modify',
    changeMsg: 'After modification, the login account will be updated as well',
    register: 'Store Register Time',
    mainModels: 'Main Vehicle Type',
    mainBrand: 'Main Brands',
    area: 'Main Sales Area',
    parts: 'Main Parts',
    IdCard: 'Legal Person\'s ID Card Front',
    IdCard2: 'Legal Person\'s ID Card Back',
    businessLicense: 'Business License',
    storeFacade: 'Store Front',

  },

  // 店铺管理——店铺列表
  shopList: {
    list: 'Store List',
    company: 'Register Company',
    status: 'Company Status',
    Store: 'Store Name',
    defaultStore: 'Default Store',
    set: 'Set as Default',
    default: 'default',
  },

  // 店铺管理——店铺信息
  storeInformation: {
    information: 'Basic Info',
    Main: 'Main Business Info',
    Certification: 'Certification Info',

    modified: 'From 2022-01-01 to 2022-12-31, the store name can be modified a total of 3 times. You have 3 modifications remaining. Please fill in the information carefully.',
    Store: 'Store Name',
    management: 'Business Adr',
    person: 'Contact Person',
    number: 'Contact Phone No.',
    registration: 'Store Register Time',
    After: 'After modification, the login account will be updated as well',
    Revise: 'Modify',
    save: 'Save',
    province: 'Please select the province',
    city: 'Please select the city',
    district: 'Please select the district',
    you: 'Please enter your name for customer or platform service to contact you',
    phone: 'Contact Phone No.',
    modification: 'After modification, the login account will be updated as well',
    time: 'Store Register Time',

    models: 'Main Vehicle Type',
    brand: 'Main Brands',
    area: 'Main Sales Area',
    accessories: 'Main Parts',

    pictures: 'No image available',
    Front: 'Legal Person\'s ID Card Front',
    Reverse: 'Legal Person\'s ID Card Back',
    business: 'Business License',
    shop: 'Store Front',
  },

  // 店铺管理——店铺装修
  StoreConstruction: {
    construction: 'Store Decoration',
    top: "Store Header Image",
    system: 'The system will automatically adjust the uploaded images, which may cause distortion. The recommended size is 1200*100 pixels',
    photo: "Store Photos",
    maximum: "(A maximum of 5 photos can be added, and a single photo cannot exceed 6M. The recommended size is 100*100)",
    Store: "Store Introduction",
    edit: "Edit",
    Finish: "Complete",
    company: 'Please edit the company\'s info.',

  },

  // 营销管理——店铺活动
  Events: {
    Store: 'Store Discount',
    all: 'All',
    progress: 'In Progress',
    started: 'To be started',
    over: 'Ended  ',

    Event: 'Activity Name',
    Accessory: 'Part Code/Part Name',
    reset: 'Reset',
    Inquire: 'Search',
    Check: 'View',
    closure: 'Close',

    // 表格
    Activity: 'Activity ID',
    operate: 'Operation',
    name: 'Name',
    type: 'Type',
    time: 'Time',
    Remark: 'Note',
    Number: 'Quantity',
    create: 'Create Info.',
    Modify: 'Create Info.',

    // 模态框
    Details: 'Activity Details',
    Purchase: 'Purchase item 1:',
    Level: 'Level 1-free for 10 or more items',
    product: 'product information',
    stock: 'stock',
    Gift: 'Gift quantity',
    Starting: 'Starting quantity',
    price: 'activity unit price',
    search: 'search',
  },

  // 账号管理——个人资料
  personal: {
    information: 'Profile',
    account: 'Account',
    until: 'Package is valid until',
    Package: 'Package name',
    Name: 'Name',
  },

  // 账号管理——收货地址
  ShippingAddress: {
    address: 'Receiving adr',
    Add: 'Add New',
    Created: 'Already Created',
    delivery: 'delivery address, you can also create',
    indivual: 'indivual',
    default: 'Default Adr',
    Revise: 'Modify',

    // 模态框
    shipping: 'Set shipping address',
    Name: 'Name',
    consignee: 'Please enter the consignee name',
    Telephone: 'Telephone',
    contact: 'Please enter contact phone number',
    location: 'location',
    province: 'Please select province',
    city: 'Please choose the city',
    district: 'Please select a district',
    Address: 'Address',
    Please: 'Please enter detailed address, up to 100 words',
    set: 'set as the default address',
    Sure: 'Confirm',
    Cancel: 'Cancel',
    as: 'Set as default billing information'
  },

  // 账号管理——发票设置
  Invoice: {
    Sure: 'Confirm',
    Settings: 'Invoice Set',
    Add: 'Add New',
    Created: 'Already Created',
    delivery: 'Invoice settings, still can be created',
    indivual: 'indivual',
    address: 'Default Adr',
    Revise: 'Revise',
    delete: 'Delete',
    number: 'Tax No.',
    default: 'Default',
    Company: 'Company Name',
    Are: 'Are you sure you want to delete this invoice information?',
  },

  // 组织管理——员工列表
  staff: {
    name: 'Name',
    Phone: 'Phone No.',
    status: 'Employment Status',
    Account: 'Account Status',
    search: 'Search',
    reset: 'Reset',
    working: 'Employed',
    Resign: 'Resigned',
    enable: 'Enable',
    Disable: 'Disable',

    Add: 'Add New',
    Revise: 'Modify',
    close: 'Close Account',
    Password: 'Reset Password',
    Number: 'Number of Employees Created',
    bit: 'bit',
    also: 'Number of Employees that can be still created',

    // 表格
    choose: 'Select',
    gender: 'Gender',
    phoneNumber: 'Phone No.',
    Role: 'Role',
  },

  // 组织管理——角色管理
  Role: {
    number: 'Serial No.',
    Add: 'Add New',
    search: 'Search',
    reset: 'Reset',
    Revise: 'Modify',
    delete: 'Delete',
    Name: 'Role Name',
    create: 'Create Info',
    Edit: 'Edit Info',
    save: 'save',
    Permission: 'Permission Setting'
  },

  //我的关注
  focus: {
    my: 'My Favorites',
    Full: 'All Favorites',
    // 表格

    picture: 'Product Image',
    info: 'Product Info',
    store: 'Store',
    place: 'Shipping adr',
    stock: 'Inventory',
    price: 'Price',
    Purchase: 'Purchase Quantity',
    Subtotal: 'Subtotal',
    operate: 'Operation',


    // 模态框
    Switch: 'Switch Store',
    Company: 'Company Name',
    storeName: 'Store Name',
    Role: 'Role Name',
    to: 'Switch',
  },

  
  // 登录
  login: {
    data1: 'Welcome to login',
    data2: 'log on',
    data3: 'Please enter your password',
    data4: 'Please enter your phone number or username',
    data5: 'Recommend using Chrome browser',
    data6: 'Account login',
  },
  // 付款界面
  payOrder: {
    ServiceCashier:'Service cashier',
    info1:'Order has been submitted, please complete the payment within',
    info2:'otherwise the order will be',
    info3:'automatically cancelled',
    minute:'minutes',
    second:'seconds',
    moneyinfo:'param money：',
    payMethod:'method of payment',
    payMethod1:'Offline transfer',
    payMethod2:'Line payment',
    paySure:'confirm the payment',
    PaymentDetails:'Payment details',
    orderNo: 'orderNo：',
    seller:'seller',
    transactionTime:'time',
    transactionAmount:'amount',

    payStatusInfo1:'Close in seconds, about to enter my [order page] to pay again',
    payStatusInfo2:'Page expired',
    payStatusInfo3: 'check an order',
    payStatusInfo4: 'payment failure',
    payStatusInfo5: 'payment success',

  }
}
